import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './accessibility.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { DarkModeProvider } from "./context/DarkModeContext";
import { AccessibilityProvider } from "./context/AccessibilityContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <DarkModeProvider>
          <AccessibilityProvider>
            <App />
          </AccessibilityProvider>
        </DarkModeProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

